// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("./node_modules/@umijs/react-refresh-webpack-plugin/client/ReactRefreshEntry.js");
__webpack_require__("./node_modules/@umijs/preset-umi/node_modules/@umijs/bundler-webpack/client/client/client.js");
var __webpack_exports__ = __webpack_require__("./.dumi/tmp/umi.ts");
